import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: to => {
      window.location = 'https://www.vitc.ltd/vehicle-test-equipment-data-capture'
    }
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import('../views/Activate.vue'),
    children: [
      {
        path: '/activate',
        name: 'activate-start',
        component: () => import('../views/activate/Start.vue'),
        meta: {
          title: 'Activate'
        }
      },
      {
        path: '/activate/confirm',
        name: 'activate-confirm',
        component: () => import('../views/activate/Confirm.vue'),
        meta: {
          title: 'Activate'
        }
      },
      {
        path: '/activate/request',
        name: 'activate-request',
        component: () => import('../views/activate/Request.vue'),
        meta: {
          title: 'Activate'
        }
      },
      {
        path: '/activate/codes',
        name: 'activate-codes',
        component: () => import('../views/activate/Codes.vue'),
        meta: {
          title: 'Activate'
        }
      }
    ]
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy.vue'),
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/Download.vue'),
    meta: {
      title: 'Download'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  switch (to.name) {
    case "activate-start":
      store.dispatch('setSubtitle', "To get started, can you tell us a bit about you and your garage");
      break;
    case "activate-confirm":
      let msg = store.state.vtsFound ?
        'Please ensure your garage details are correct before continuing' :
        `We couldn't find details for that VTS number, please enter your garage details`;
      store.dispatch('setSubtitle', msg);
      break;
    case "activate-request":
      store.dispatch('setSubtitle', "Request activation codes");
      break;
    case "activate-codes":
      store.dispatch('setSubtitle', "Thank you, your activation codes are listed below");
      break;
    default:
      store.dispatch('setSubtitle', "");
      break;
  }

  if (store.state.currentStep != to.name && to.path != '/' && to.name != 'privacy' && to.name != 'download') {
    next({ name: store.state.currentStep })
  }
  else {
    next()
  }
})

export default router
